import { getEmployee } from "components/AdminNew/Redux/Selectors"
import React from "react"
import { useSelector } from "react-redux"
import AuthorizationService from "../Models/AuthorizationService"

export const usePermissions = (permission) => {
  const employee = useSelector(getEmployee)
  return AuthorizationService.isAuthorized(employee, permission)
}
